/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React, { useRef } from 'react'
import clsx from 'clsx'
import useTableHeight from 'utils/hooks/useTableHeight'

interface TableWrapperProps {
    className?: string
    tableClassName?: string
    children: React.ReactNode | React.ReactNode[]
    tableMinHeightClass?: string
    footer?: React.ReactNode
    topBar?: React.ReactNode
    tableScrollKey?: string
    tableMinContentWidthPx?: number
}

const TableWrapper = (props: TableWrapperProps) => {
    const tableRef = useRef<HTMLDivElement>(null)
    const dynamicHeight = useTableHeight(tableRef, 24) // 24px for bottom padding (p-6 in UiPage)

    return (
        <div
            ref={tableRef}
            data-table-scroll-key={props.tableScrollKey}
            className={clsx(
                'TableWrapper TanstackTableWrapper bg-white dark:bg-gray-950 border border-gray-200 dark:border-gray-800 overflow-hidden flex flex-col flex-1 grow min-h-0',
                props.className && props.className
            )}
            style={props.tableMinHeightClass ? {} : { height: dynamicHeight || 'auto' }}
        >
            <div className={clsx('flex-1 min-h-0 flex flex-col')}>
                {props.topBar}
                <div
                    className={clsx(
                        'flex-1 overflow-auto custom-scrollbar bg-white dark:bg-gray-950',
                        props.tableMinHeightClass
                    )}
                >
                    <table
                        className={clsx(
                            'relative min-h-full w-full text-gray-900 dark:text-gray-100',
                            'table-fixed',
                            props.tableClassName
                        )}
                        style={{
                            minWidth: props.tableMinContentWidthPx
                                ? `max(100%, ${props.tableMinContentWidthPx}px)`
                                : '100%',
                        }}
                    >
                        {props.children}
                    </table>
                </div>
                {props.footer && <div className="mt-auto">{props.footer}</div>}
            </div>
        </div>
    )
}

export default TableWrapper
